import MiPerfil from '@/pages/mi-perfil/Index.jsx'
import SeleccionCuenta from '@/pages/seleccion-cuenta/Index.jsx'
import MicrofrontendRemotePage from '@/pages/microfrontends/MicrofrontendRemotePage.jsx'
import NotFound from '@/pages/not-found/Index.jsx'
import { Navigate } from 'react-router-dom'

export const rutasProtegidas = [
  {
    path: '/',
    element: <></>,
    meta: {
      title: 'Inicio',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/certificados/*',
    element: <MicrofrontendRemotePage microfrontend="certificados" />,
    meta: {
      title: 'Certificados de Cobertura',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/certificados-cobertura/*',
    element: <Navigate to="/certificados" replace />,
    meta: {
      title: 'Certificados de Cobertura',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/nomina/*',
    element: <MicrofrontendRemotePage microfrontend="nomina" />,
    meta: {
      title: 'Nómina',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/nomina-trabajadores/*',
    element: <Navigate to="/nomina" replace />,
    meta: {
      title: 'Nómina',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/informe-siniestralidad/*',
    element: <MicrofrontendRemotePage microfrontend="informes" />,
    meta: {
      title: 'Informes',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/informes-siniestralidad/*',
    element: <Navigate to="/informe-siniestralidad" replace />,
    meta: {
      title: 'Informes',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/informes/*',
    element: <Navigate to="/informe-siniestralidad" replace />,
    meta: {
      title: 'Informes',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/informes-ingenieria-siniestralidad/*',
    element: <Navigate to="/informe-siniestralidad" replace />,
    meta: {
      title: 'Informes',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/credenciales/*',
    element: <MicrofrontendRemotePage microfrontend="credenciales" />,
    meta: {
      title: 'Credenciales',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/administracion-usuarios/*',
    element: <MicrofrontendRemotePage microfrontend="administracion-usuario" />,
    meta: {
      title: 'Administración de usuarios',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/informe-cancerigeno/*',
    element: <MicrofrontendRemotePage microfrontend="informe-cancerigeno" />,
    meta: {
      title: 'Informe Cancerígeno',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/rar/*',
    element: <MicrofrontendRemotePage microfrontend="rar" />,
    meta: {
      title: 'RAR',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/menu-clientes',
    element: <Navigate to="/" replace />,
    meta: {
      title: 'Menú',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/mi-perfil',
    element: <MiPerfil />,
    meta: {
      title: 'Mi Perfil',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
  {
    path: '/seleccion-cuenta',
    element: <SeleccionCuenta />,
    meta: {
      title: 'Selección de cuenta',
      requiereAdmin: false,
      requiereIdCertificado: false,
    },
  },
]

export const rutasPublicas = [
  {
    path: '/login',
    element: <NotFound />,
    meta: {
      title: 'Login',
    },
  },
]
